var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-page-top" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.show
          ? _c(
              "div",
              {
                staticClass: "button is-primary",
                on: {
                  click: function($event) {
                    return _vm.goPagetop()
                  }
                }
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("play_arrow")
                  ])
                ])
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }